export const strongPasswordRegex = RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})')
export const required = (errorMessage) => v => !!v || errorMessage
export const email = (message) => v => /.+@.+/.test(v) || message
export const minLength = (field, length) => v => v.length <= length || `${field} must be less than ${length} characters`
export const maxLength = (field, length) => v => v.length >= length || `${field} must be less than ${length} characters`
export const strongPassword = (message) => v => strongPasswordRegex.test(v) || message
export const confirmPassword = (pass1, pass2, message) => v => pass1 === pass2 || message
export const minValue = (field, val) => v => v > val || `${field} must be greater than ${val}.`
export const maxValue = (field, val) => v => v < val || `${field} must be lesser than ${val}.`
export const minCurrency = (val, error) => v => Number(v.replace(/[^0-9.-]+/g, '')) > val || error
export const maxCurrency = (val, error) => v => Number(v.replace(/[^0-9.-]+/g, '')) < val || error
export const divisibleBy10 = (error) => v => Number(v.replace(/[^0-9.-]+/g, '')) % 10 === 0 || error
export const Validations = {
  required,
  email,
  minLength,
  maxLength,
  strongPassword,
  confirmPassword,
  minValue
}
// TODO: Make VUEX like mapValidators to get only the required
